var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "column", gap: "10px" },
    },
    [
      false
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  gap: "10px",
                  "align-items": "center",
                },
              },
              [
                _c("div", [_vm._v("Select BioIndex:")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedBI,
                        expression: "selectedBI",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedBI = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.selectBioIndex($event.target.value)
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.singleCellBI, function (bi) {
                    return _c("option", { domProps: { value: bi.bioIndex } }, [
                      _vm._v(" " + _vm._s(bi.name) + " "),
                    ])
                  }),
                  0
                ),
                _c("b-pagination", {
                  staticClass:
                    "pagination datasets-page justify-content-center",
                  attrs: {
                    "total-rows": _vm.totalDatasets,
                    "per-page": _vm.datasetsPerPage,
                  },
                  model: {
                    value: _vm.currentDatasetsPage,
                    callback: function ($$v) {
                      _vm.currentDatasetsPage = $$v
                    },
                    expression: "currentDatasetsPage",
                  },
                }),
              ],
              1
            ),
            _vm.filteredMetadata
              ? _c("b-table", {
                  attrs: {
                    items: _vm.filteredMetadata,
                    fields: _vm.tableColumns,
                    striped: "",
                    hover: "",
                    responsive: "sm",
                    "head-variant": "light",
                    "per-page": _vm.datasetsPerPage,
                    "current-page": _vm.currentDatasetsPage,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(datasetId)",
                        fn: function (data) {
                          return [
                            data.item.datasetId !== _vm.datasetId
                              ? _c(
                                  "button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectDataset(
                                          data.item.datasetId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Select")]
                                )
                              : _c("div", [_vm._v("Selected")]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3917555800
                  ),
                })
              : _vm._e(),
            _vm.datasetId
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "10px",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", [_vm._v("Select Layout:")]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.layout,
                            expression: "layout",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.layout = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.selectLayout($event.target.value)
                            },
                          ],
                        },
                      },
                      _vm._l(_vm.layoutOptions, function (layout) {
                        return _c(
                          "option",
                          { domProps: { value: layout.value } },
                          [_vm._v(" " + _vm._s(layout.name) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      false
        ? [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("Select Tissue"),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.datasetId,
                    expression: "datasetId",
                  },
                ],
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.datasetId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function ($event) {
                      return _vm.selectDataset(_vm.data.item.datasetId)
                    },
                  ],
                },
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("--Select--"),
                ]),
                _vm._l(_vm.singleCellMetadata, function (item) {
                  return _c("option", { domProps: { value: item.datasetId } }, [
                    _vm._v(
                      _vm._s(item.tissue) +
                        " (" +
                        _vm._s(item.totalCells.toLocaleString()) +
                        " cells)"
                    ),
                  ])
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm.showDatasetSelect
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "10px",
              },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: { "font-weight": "bold", "font-size": "16px" },
                  },
                  [
                    _vm._v(
                      "Select Tissue (" +
                        _vm._s(_vm.singleCellMetadata.length) +
                        ")"
                    ),
                  ]
                ),
                _c("div", [_vm._v("Click on a row to select")]),
              ]),
              _vm.singleCellMetadata
                ? _c("b-table", {
                    attrs: {
                      items: _vm.singleCellMetadata,
                      fields: _vm.tableColumns,
                      "sort-by": "tissue",
                      small: "",
                      striped: "",
                      hover: "",
                      responsive: "sm",
                      "head-variant": "light",
                      "sticky-header": "300px",
                      "per-page": _vm.datasetsPerPage,
                      "current-page": _vm.currentDatasetsPage,
                      "tbody-tr-class": _vm.datasetsRowClass,
                    },
                    on: {
                      "row-clicked": (item) =>
                        _vm.selectDataset(item.datasetId),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(datasetId)",
                          fn: function (data) {
                            return [
                              data.item.datasetId !== _vm.datasetId
                                ? _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectDataset(
                                            data.item.datasetId
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Select")]
                                  )
                                : _c("div", [_vm._v("Selected")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3917555800
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.datasetId
        ? _c("div", { staticStyle: { color: "red", margin: "0 auto" } }, [
            _vm._v(" Please Select a Dataset "),
          ])
        : _vm._e(),
      _vm.datasetId && !_vm.dataLoaded && !_vm.loadError
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                gap: "8px",
                margin: "0 auto",
              },
            },
            [
              _c("div", { staticClass: "geneLoader" }),
              _c("div", [_vm._v("Loading " + _vm._s(_vm.preloadItem) + "...")]),
            ]
          )
        : _vm._e(),
      _vm.loadError
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "5px",
                margin: "0 auto",
                "max-width": "600px",
                padding: "15px",
                border: "1px solid #e0b4b4",
                background: "#fff6f6",
                "border-radius": "3px",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { "font-weight": "bold", color: "#912d2b" } },
                [_vm._v("This dataset could not be loaded")]
              ),
              _c("div", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(_vm._s(_vm.loadError.message)),
              ]),
              _vm.loadError.detail
                ? _c(
                    "div",
                    { staticStyle: { "font-size": "12px", opacity: "0.7" } },
                    [_vm._v(_vm._s(_vm.loadError.detail))]
                  )
                : _vm._e(),
              _vm.isDev && _vm.loadError.url
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "11px",
                        opacity: "0.6",
                        "word-break": "break-all",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.loadError.url) + " ")]
                  )
                : _vm._e(),
              _vm.showDatasetSelect
                ? _c("div", { staticStyle: { "font-size": "13px" } }, [
                    _vm._v("Select another tissue above to continue."),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.dataLoaded
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "20px",
                width: "100%",
                "max-width": "100%",
                "overflow-x": "auto",
              },
            },
            [
              _vm.layout === 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "20px",
                        background: "#f8f8f8",
                        padding: "20px",
                        width: "100%",
                        "min-width": "840px",
                      },
                    },
                    [
                      _vm.metadata
                        ? _c("research-single-cell-info", {
                            attrs: { data: _vm.metadata },
                          })
                        : _vm._e(),
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                gap: "20px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "flex", gap: "20px" },
                                },
                                [
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "20px",
                                            flex: "1",
                                            padding: "20px",
                                            background: "white",
                                            "max-width": "50%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                width: "min-content",
                                                flex: "1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    "align-items": "baseline",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [_vm._v("Embedding")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.embeddingType
                                                        )
                                                    ),
                                                  ]),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(_vm.cellCountLabel)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("research-umap-plot-gl", {
                                                attrs: {
                                                  downloadFilename:
                                                    _vm.umapDownloadFilename,
                                                  group: _vm.datasetId,
                                                  points: _vm.coordinates,
                                                  labels: _vm.fields,
                                                  colors: _vm.labelColors,
                                                  cellTypeField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  colorByField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  hoverFields: [],
                                                  highlightLabel:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  highlightLabels:
                                                    _vm.cellCompositionVars
                                                      .highlightLabels,
                                                  visibleMask:
                                                    _vm.cellFilterMask,
                                                  width: 400,
                                                  height: 400,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.colorByFields
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    "align-self": "flex-start",
                                                    width: "200px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                        margin: "0 0 5px",
                                                      },
                                                    },
                                                    [_vm._v("Color By")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        height: "400px",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .colorByField,
                                                              expression:
                                                                "cellCompositionVars.colorByField",
                                                            },
                                                          ],
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  _vm.cellCompositionVars,
                                                                  "colorByField",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.selectColorBy(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "--Select--"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.colorByFields
                                                              .show,
                                                            function (
                                                              value,
                                                              key
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value: key,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          key
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "flex-grow": "1",
                                                            "overflow-x":
                                                              "hidden",
                                                            "overflow-y":
                                                              "auto",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "research-single-cell-selector",
                                                            {
                                                              attrs: {
                                                                data:
                                                                  _vm.fields[
                                                                    "metadata_labels_sorted"
                                                                  ] ||
                                                                  _vm.fields[
                                                                    "metadata_labels"
                                                                  ],
                                                                displayData:
                                                                  _vm.displayFields,
                                                                selectedField:
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .colorByField,
                                                                layout: "list",
                                                                colors:
                                                                  _vm.labelColors,
                                                              },
                                                              on: {
                                                                "on-update":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorUpdate(
                                                                      $event
                                                                    )
                                                                  },
                                                                "on-hover":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorHover(
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "20px",
                                            flex: "1",
                                            padding: "20px",
                                            background: "white",
                                            "max-width": "50%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                width: "min-content",
                                                flex: "1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    "align-items": "baseline",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .geneExpressionVars
                                                              .selectedGene
                                                              ? `${_vm.geneExpressionVars.selectedGene}`
                                                              : "Gene"
                                                          ) + " Expression"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.embeddingType
                                                        )
                                                    ),
                                                  ]),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(_vm.cellCountLabel)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative",
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c("research-umap-plot-gl", {
                                                    attrs: {
                                                      downloadFilename:
                                                        _vm.umapExpressionDownloadFilename,
                                                      group: _vm.datasetId,
                                                      points: _vm.coordinates,
                                                      labels: _vm.fields,
                                                      colors: _vm.labelColors,
                                                      expression:
                                                        _vm.expressionData[
                                                          _vm.geneExpressionVars
                                                            .selectedGene
                                                        ],
                                                      expressionColorScale:
                                                        _vm.expressionColorScale,
                                                      cellTypeField:
                                                        _vm.cellCompositionVars
                                                          .colorByField,
                                                      hoverFields: [],
                                                      highlightLabel:
                                                        _vm.cellCompositionVars
                                                          .highlightLabel,
                                                      highlightLabels:
                                                        _vm.cellCompositionVars
                                                          .highlightLabels,
                                                      visibleMask:
                                                        _vm.cellFilterMask,
                                                      width: 400,
                                                      height: 400,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                "align-self": "flex-start",
                                                width: "200px",
                                              },
                                            },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [_vm._v("Gene Search")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    height: "400px",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.geneToSearch,
                                                            expression:
                                                              "geneToSearch",
                                                          },
                                                        ],
                                                        staticStyle: {
                                                          width: "100%",
                                                          position: "relative",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Gene name",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.geneToSearch,
                                                        },
                                                        on: {
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            )
                                                              return null
                                                            return _vm.searchGene(
                                                              _vm.geneToSearch
                                                            )
                                                          },
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.geneToSearch =
                                                              $event.target.value
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "button",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.searchGene(
                                                                _vm.geneToSearch
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticStyle: {
                                                                width: "20px",
                                                              },
                                                              style: `display:${
                                                                !_vm.geneLoading
                                                                  ? "block"
                                                                  : "none"
                                                              }`,
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 24 24",
                                                                fill: "none",
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                stroke: "#000",
                                                              },
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  "fill-rule":
                                                                    "evenodd",
                                                                  "clip-rule":
                                                                    "evenodd",
                                                                  d: "M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z",
                                                                  fill: "#080341",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "geneLoader",
                                                            style: `display:${
                                                              _vm.geneLoading
                                                                ? "block"
                                                                : "none"
                                                            }`,
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.genesNotFound.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                            gap: "1px",
                                                            flex: "0 0 auto",
                                                            "max-height":
                                                              "100%",
                                                            "overflow-y":
                                                              "auto",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.genesNotFound,
                                                          function (gene) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  gap: "5px",
                                                                  width: "100%",
                                                                  background:
                                                                    "#ff4500",
                                                                  color:
                                                                    "white",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "flex",
                                                                        flex: "1",
                                                                        "align-items":
                                                                          "center",
                                                                        padding:
                                                                          "0 5px",
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        gene
                                                                      ) +
                                                                        " not found."
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "28px",
                                                                        height:
                                                                          "28px",
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center",
                                                                        "justify-content":
                                                                          "center",
                                                                        "font-size":
                                                                          "18px",
                                                                        "line-height":
                                                                          "18px",
                                                                        cursor:
                                                                          "pointer",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clearGeneNotFound(
                                                                            gene
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [_vm._v("×")]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "research-single-cell-selector",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "4px",
                                                        "flex-grow": "1",
                                                        "overflow-x": "hidden",
                                                        "overflow-y": "auto",
                                                      },
                                                      attrs: {
                                                        data: _vm.sortedGeneNames,
                                                        layout: "list",
                                                        listSelection:
                                                          "exclusive",
                                                        colors: null,
                                                        selectedField:
                                                          _vm.geneExpressionVars
                                                            .selectedGene,
                                                      },
                                                      on: {
                                                        "on-update": function (
                                                          $event
                                                        ) {
                                                          return _vm.geneClick(
                                                            $event
                                                              .coloredLabels[0]
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    gap: "5px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        padding: "20px",
                                        background: "white",
                                        gap: "15px",
                                      },
                                    },
                                    [
                                      _vm.filterableFields.length
                                        ? _c(
                                            "div",
                                            {
                                              ref: "cellFilter",
                                              staticClass: "cell-filter",
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                                gap: "8px",
                                                "align-items": "center",
                                                "min-width": "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                    "font-size": "16px",
                                                    "white-space": "nowrap",
                                                  },
                                                },
                                                [_vm._v("Filter")]
                                              ),
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "info-circle-fill",
                                                  variant: "secondary",
                                                },
                                                on: {
                                                  mouseover: function ($event) {
                                                    return _vm.showTooltip(
                                                      _vm.filterTooltip
                                                    )
                                                  },
                                                  mouseout: function ($event) {
                                                    return _vm.hideTooltip()
                                                  },
                                                },
                                              }),
                                              _c(
                                                "button",
                                                {
                                                  ref: "cellFilterToggle",
                                                  staticStyle: {
                                                    "white-space": "nowrap",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.filterPanelOpen =
                                                        !_vm.filterPanelOpen
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.filterPanelOpen
                                                          ? "Hide"
                                                          : "Add filter"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm.cellFilter
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "13px",
                                                        "white-space": "nowrap",
                                                      },
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.filteredCellCount.toLocaleString()
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        " of " +
                                                          _vm._s(
                                                            _vm.cellFilter.totalCount.toLocaleString()
                                                          ) +
                                                          " " +
                                                          _vm._s(_vm.cellNoun) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.activeFilterFields.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-wrap": "wrap",
                                                        gap: "5px",
                                                        "min-width": "0",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.activeFilterFields,
                                                      function (field) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: `chip-${field}`,
                                                            staticStyle: {
                                                              display: "flex",
                                                              gap: "4px",
                                                              "align-items":
                                                                "center",
                                                              "font-size":
                                                                "12px",
                                                              background:
                                                                "#eef3f8",
                                                              border:
                                                                "1px solid #cfdbe6",
                                                              "border-radius":
                                                                "12px",
                                                              padding:
                                                                "1px 8px",
                                                              "max-width":
                                                                "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-weight":
                                                                    "bold",
                                                                  "white-space":
                                                                    "nowrap",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      field
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  overflow:
                                                                    "hidden",
                                                                  "text-overflow":
                                                                    "ellipsis",
                                                                  "white-space":
                                                                    "nowrap",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.filterSummaryFor(
                                                                        field
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  cursor:
                                                                    "pointer",
                                                                  "font-weight":
                                                                    "bold",
                                                                  opacity:
                                                                    "0.6",
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    "Remove this filter",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clearFieldFilter(
                                                                        field
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("×")]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _vm.activeFilterFields.length
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticStyle: {
                                                        "white-space": "nowrap",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearAllFilters()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Clear all")]
                                                  )
                                                : _vm._e(),
                                              _vm.filterPanelOpen
                                                ? _c(
                                                    "div",
                                                    {
                                                      ref: "cellFilterPanel",
                                                      staticClass:
                                                        "cell-filter-panel",
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "10px",
                                                        "align-items":
                                                          "flex-start",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                            gap: "2px",
                                                            "max-height":
                                                              "260px",
                                                            overflow: "auto",
                                                            "min-width":
                                                              "180px",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.filterableFields,
                                                          function (field) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: `field-${field}`,
                                                                style: `cursor:pointer; font-size:13px; padding:2px 5px; white-space:nowrap; ${
                                                                  _vm.openFilterField ===
                                                                  field
                                                                    ? "background:#eef3f8; font-weight:bold;"
                                                                    : ""
                                                                }`,
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toggleFilterField(
                                                                        field
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.displayLabel(
                                                                        field
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _vm
                                                                  .cellFilterSelections[
                                                                  field
                                                                ]
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            opacity:
                                                                              "0.6",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "•"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _vm.openFilterField
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                "flex-direction":
                                                                  "column",
                                                                gap: "4px",
                                                                "min-width":
                                                                  "0",
                                                              },
                                                            },
                                                            [
                                                              _vm.isRangeFilterField(
                                                                _vm.openFilterField
                                                              )
                                                                ? [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            gap: "5px",
                                                                            "align-items":
                                                                              "center",
                                                                            "font-size":
                                                                              "11px",
                                                                            opacity:
                                                                              "0.6",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .numericRangeFor(
                                                                                  _vm.openFilterField
                                                                                )
                                                                                .valueCount.toLocaleString()
                                                                            ) +
                                                                            " distinct values "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "research-range-slider",
                                                                      {
                                                                        key: `range-${_vm.openFilterField}`,
                                                                        attrs: {
                                                                          min: _vm.numericRangeFor(
                                                                            _vm.openFilterField
                                                                          ).min,
                                                                          max: _vm.numericRangeFor(
                                                                            _vm.openFilterField
                                                                          ).max,
                                                                          step: _vm.numericRangeFor(
                                                                            _vm.openFilterField
                                                                          )
                                                                            .step,
                                                                          decimals:
                                                                            _vm.numericRangeFor(
                                                                              _vm.openFilterField
                                                                            )
                                                                              .decimals,
                                                                          value:
                                                                            _vm.rangeValueFor(
                                                                              _vm.openFilterField
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.setFilterRange(
                                                                                _vm.openFilterField,
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            gap: "5px",
                                                                            "align-items":
                                                                              "center",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    _vm.filterSearch,
                                                                                  expression:
                                                                                    "filterSearch",
                                                                                },
                                                                              ],
                                                                            staticStyle:
                                                                              {
                                                                                "font-size":
                                                                                  "12px",
                                                                                width:
                                                                                  "160px",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Search values",
                                                                              },
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  _vm.filterSearch,
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  if (
                                                                                    $event
                                                                                      .target
                                                                                      .composing
                                                                                  )
                                                                                    return
                                                                                  _vm.filterSearch =
                                                                                    $event.target.value
                                                                                },
                                                                            },
                                                                          }
                                                                        ),
                                                                        _vm
                                                                          .cellFilterSelections[
                                                                          _vm
                                                                            .openFilterField
                                                                        ]
                                                                          ? _c(
                                                                              "button",
                                                                              {
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.clearFieldFilter(
                                                                                        _vm.openFilterField
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Clear"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                "font-size":
                                                                                  "11px",
                                                                                opacity:
                                                                                  "0.6",
                                                                                "white-space":
                                                                                  "nowrap",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  _vm.openFilterLabels.length.toLocaleString()
                                                                                ) +
                                                                                " of " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .filterLabelsFor(
                                                                                      _vm.openFilterField
                                                                                    )
                                                                                    .length.toLocaleString()
                                                                                ) +
                                                                                " values "
                                                                            ),
                                                                            _vm.hiddenFilterLabelCount
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      " — search to reach the other " +
                                                                                        _vm._s(
                                                                                          _vm.hiddenFilterLabelCount.toLocaleString()
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            "flex-direction":
                                                                              "column",
                                                                            "max-height":
                                                                              "220px",
                                                                            overflow:
                                                                              "auto",
                                                                            "min-width":
                                                                              "220px",
                                                                          },
                                                                      },
                                                                      _vm._l(
                                                                        _vm.openFilterLabels,
                                                                        function (
                                                                          label
                                                                        ) {
                                                                          return _c(
                                                                            "label",
                                                                            {
                                                                              key: `val-${label}`,
                                                                              staticStyle:
                                                                                {
                                                                                  display:
                                                                                    "flex",
                                                                                  gap: "5px",
                                                                                  "align-items":
                                                                                    "center",
                                                                                  "font-size":
                                                                                    "12px",
                                                                                  "font-weight":
                                                                                    "normal",
                                                                                  margin:
                                                                                    "0",
                                                                                  padding:
                                                                                    "1px 0",
                                                                                  cursor:
                                                                                    "pointer",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "checkbox",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      checked:
                                                                                        _vm.isFilterLabelSelected(
                                                                                          _vm.openFilterField,
                                                                                          label
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.toggleFilterValue(
                                                                                          _vm.openFilterField,
                                                                                          label
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      overflow:
                                                                                        "hidden",
                                                                                      "text-overflow":
                                                                                        "ellipsis",
                                                                                      "white-space":
                                                                                        "nowrap",
                                                                                    },
                                                                                  style:
                                                                                    _vm.isMissingLabel(
                                                                                      label
                                                                                    )
                                                                                      ? "font-style:italic; opacity:0.7;"
                                                                                      : "",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.filterLabelDisplay(
                                                                                          label
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm.facetCountFor(
                                                                                _vm.openFilterField,
                                                                                label
                                                                              ) !==
                                                                              null
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      style: `margin-left:auto; opacity:${
                                                                                        _vm.facetCountFor(
                                                                                          _vm.openFilterField,
                                                                                          label
                                                                                        )
                                                                                          ? 0.6
                                                                                          : 0.35
                                                                                      }; white-space:nowrap;`,
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .facetCountFor(
                                                                                                _vm.openFilterField,
                                                                                                label
                                                                                              )
                                                                                              .toLocaleString()
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ],
                                                            ],
                                                            2
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                opacity: "0.6",
                                                                padding: "5px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Select a field to filter by. "
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "row",
                                            "flex-wrap": "wrap",
                                            gap: "20px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                gap: "5px",
                                                "align-items": "center",
                                                width: "300px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                    "font-size": "16px",
                                                    "white-space": "nowrap",
                                                  },
                                                },
                                                [_vm._v("Group By")]
                                              ),
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "info-circle-fill",
                                                  variant: "secondary",
                                                },
                                                on: {
                                                  mouseover: function ($event) {
                                                    return _vm.showTooltip(
                                                      "Select primary annotation<br/>by which to group the data."
                                                    )
                                                  },
                                                  mouseout: function ($event) {
                                                    return _vm.hideTooltip()
                                                  },
                                                },
                                              }),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.activeGroup,
                                                      expression: "activeGroup",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    width: "100%",
                                                    "max-width": "500px",
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.activeGroup = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      },
                                                      _vm.handleSampleChange,
                                                    ],
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.groupByFields,
                                                  function (option) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: `group-${option}`,
                                                        domProps: {
                                                          value: option,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              option
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                gap: "5px",
                                                "align-items": "center",
                                                width: "300px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                    "font-size": "16px",
                                                    "white-space": "nowrap",
                                                  },
                                                },
                                                [_vm._v("Stratify By")]
                                              ),
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: "info-circle-fill",
                                                  variant: "secondary",
                                                },
                                                on: {
                                                  mouseover: function ($event) {
                                                    return _vm.showTooltip(
                                                      "Select secondary annotation<br/>by which to stratify grouped data."
                                                    )
                                                  },
                                                  mouseout: function ($event) {
                                                    return _vm.hideTooltip()
                                                  },
                                                },
                                              }),
                                              _c(
                                                "select",
                                                {
                                                  staticStyle: {
                                                    width: "200px",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.selectSegmentBy(
                                                        _vm.cellCompositionVars
                                                          .displayByLabel,
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "" } },
                                                    [_vm._v("--Select--")]
                                                  ),
                                                  _vm._l(
                                                    _vm.traitFields.show,
                                                    function (value, key) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value: key,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  key
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  Object.keys(
                                                    _vm.traitFields.hide
                                                  ).length > 0
                                                    ? _c(
                                                        "optgroup",
                                                        {
                                                          attrs: {
                                                            label: "Unused",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.traitFields.hide,
                                                          function (
                                                            value,
                                                            key
                                                          ) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  disabled: "",
                                                                },
                                                                domProps: {
                                                                  value: key,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.displayLabel(
                                                                        key
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      ref: "expressionPanels",
                                      staticStyle: {
                                        display: "flex",
                                        gap: "0",
                                        "align-items": "stretch",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "20px",
                                            padding: "20px",
                                            background: "white",
                                            "min-width": "0",
                                          },
                                          style: _vm.resizableColumnStyle(
                                            _vm.leftPanelWidth
                                          ),
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                gap: "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isATACseq
                                                            ? "Nuclei"
                                                            : "Cell"
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.isNormalized
                                                              ? "Proportion"
                                                              : "Count"
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.displayFields &&
                                                  _vm.cellCompositionVars
                                                    .segmentByLabel &&
                                                  _vm.displayFields[
                                                    _vm.cellCompositionVars
                                                      .segmentByLabel
                                                  ].dataType === "cat"
                                                    ? [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" per "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm.cellCompositionVars
                                                        .segmentByLabel
                                                    ? [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" per "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm.displayFields &&
                                                  _vm.cellCompositionVars
                                                    .segmentByLabel &&
                                                  _vm.displayFields[
                                                    _vm.cellCompositionVars
                                                      .segmentByLabel
                                                  ].dataType === "cont"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Each point represents the average " +
                                                                _vm._s(
                                                                  _vm.isATACseq
                                                                    ? "nuclei"
                                                                    : "cell"
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.isNormalized
                                                                    ? "proportion"
                                                                    : "distribution"
                                                                ) +
                                                                " per " +
                                                                _vm._s(
                                                                  this
                                                                    .aggregateType
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              _c("download-chart", {
                                                staticStyle: {
                                                  width: "125px",
                                                  "align-self": "flex-start",
                                                },
                                                style: `${
                                                  _vm.countDownloadDisabled
                                                    ? "pointer-events:none; opacity:0.5"
                                                    : ""
                                                }`,
                                                attrs: {
                                                  chartId:
                                                    _vm.countDownloadChartId,
                                                  titleText:
                                                    _vm.countSectionTitle,
                                                  filename:
                                                    _vm.countDownloadFilename,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          !_vm.cellCompositionVars
                                            .segmentByLabel ||
                                          (_vm.displayFields &&
                                            _vm.displayFields[
                                              _vm.cellCompositionVars
                                                .segmentByLabel
                                            ].dataType === "cat")
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "research-stacked-bar-plot",
                                                    {
                                                      attrs: {
                                                        data: _vm
                                                          .cellCompositionVars
                                                          .segmentByCounts2,
                                                        primaryKey: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .displayByLabel,
                                                        subsetKey: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel,
                                                        xAxisLabel:
                                                          _vm.useVerticalCellProportionPlot
                                                            ? `${
                                                                _vm.isNormalized
                                                                  ? "Percent of " +
                                                                    (_vm.isATACseq
                                                                      ? "Nuclei"
                                                                      : "Cells")
                                                                  : "Number of " +
                                                                    (_vm.isATACseq
                                                                      ? "Nuclei"
                                                                      : "Cells")
                                                              }`
                                                            : _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                            ? _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .segmentByLabel
                                                              )
                                                            : _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .displayByLabel
                                                              ),
                                                        yAxisLabel:
                                                          _vm.useVerticalCellProportionPlot
                                                            ? _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                              ? _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                )
                                                              : _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                            : `${
                                                                _vm.isNormalized
                                                                  ? "Percent of " +
                                                                    (_vm.isATACseq
                                                                      ? "Nuclei"
                                                                      : "Cells")
                                                                  : "Number of " +
                                                                    (_vm.isATACseq
                                                                      ? "Nuclei"
                                                                      : "Cells")
                                                              }`,
                                                        highlightKey:
                                                          _vm
                                                            .cellCompositionVars
                                                            .highlightLabel,
                                                        normalize:
                                                          _vm.isNormalized,
                                                        stack: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? true
                                                          : false,
                                                        verticalCategoryLayout:
                                                          _vm.useVerticalCellProportionPlot,
                                                      },
                                                    }
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        opacity: "0.5",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel
                                                            ? _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .displayByLabel
                                                              )
                                                            : _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .segmentByLabel
                                                              )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "research-single-cell-selector",
                                                    {
                                                      attrs: {
                                                        data: _vm.plotMetadataLabels,
                                                        layout: "list",
                                                        listDirection:
                                                          "horizontal",
                                                        listAlignment: "start",
                                                        colors: _vm.labelColors,
                                                        selectedField: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel,
                                                      },
                                                      on: {
                                                        "on-update": function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSelectorUpdate(
                                                            $event
                                                          )
                                                        },
                                                        "on-hover": function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSelectorHover(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.contCountResults
                                            ? _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    id: "sc_count_scatter_group",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        opacity: "0.5",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.displayLabel(
                                                            _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-wrap": "wrap",
                                                        gap: "10px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.contCountResults,
                                                      function (item) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "min-width":
                                                                "250px",
                                                              flex: "1",
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.groupKey
                                                                )
                                                              ),
                                                            ]),
                                                            _c(
                                                              "research-scatter-plot",
                                                              {
                                                                attrs: {
                                                                  data: item.data,
                                                                  width: 300,
                                                                  height: 150,
                                                                  xKey: _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel,
                                                                  yKey: "cell_proportion",
                                                                  xLabel:
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    ),
                                                                  yLabel:
                                                                    "Cell Proportion",
                                                                  yDomain: [
                                                                    0, 1,
                                                                  ],
                                                                  renderAs:
                                                                    "svg",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm.geneExpressionVars.expressionStats
                                        .length > 0
                                        ? _c("div", {
                                            style: _vm.resizeHandleStyle,
                                            on: {
                                              mousedown: _vm.startColumnResize,
                                              touchstart: function ($event) {
                                                $event.preventDefault()
                                                return _vm.startColumnResize.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.geneExpressionVars.expressionStats
                                        .length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                gap: "20px",
                                                padding: "20px",
                                                background: "white",
                                                "min-width": "0",
                                              },
                                              style: _vm.resizableColumnStyle(
                                                _vm.rightPanelWidth
                                              ),
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    gap: "3px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                        gap: "10px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "bold",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .geneExpressionVars
                                                                    .selectedGene
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.isATACseq
                                                                      ? "Chromatin Accessibility"
                                                                      : "Expression"
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.displayFields &&
                                                          _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel &&
                                                          _vm.displayFields[
                                                            _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          ].dataType === "cat"
                                                            ? [
                                                                _vm._v(" by "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-style":
                                                                          "italic",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .displayByLabel
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" per "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-style":
                                                                          "italic",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .segmentByLabel
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                            ? [
                                                                _vm._v(" by "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-style":
                                                                          "italic",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .segmentByLabel
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" per "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-style":
                                                                          "italic",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .displayByLabel
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : [
                                                                _vm._v(" by "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-style":
                                                                          "italic",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .displayByLabel
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                          _vm.displayFields &&
                                                          _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel &&
                                                          _vm.displayFields[
                                                            _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          ].dataType === "cont"
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Each point represents the average " +
                                                                        _vm._s(
                                                                          _vm.isATACseq
                                                                            ? "chromatin accessibility"
                                                                            : "gene expression"
                                                                        ) +
                                                                        " per " +
                                                                        _vm._s(
                                                                          this
                                                                            .aggregateType
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : _vm._e(),
                                                          !_vm.coordinates
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    "flex-direction":
                                                                      "column",
                                                                    gap: "5px",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          gap: "5px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm.geneToSearch,
                                                                                expression:
                                                                                  "geneToSearch",
                                                                              },
                                                                            ],
                                                                          staticStyle:
                                                                            {
                                                                              width:
                                                                                "100%",
                                                                              position:
                                                                                "relative",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              type: "text",
                                                                              placeholder:
                                                                                "Gene name",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                _vm.geneToSearch,
                                                                            },
                                                                          on: {
                                                                            keyup:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  !$event.type.indexOf(
                                                                                    "key"
                                                                                  ) &&
                                                                                  _vm._k(
                                                                                    $event.keyCode,
                                                                                    "enter",
                                                                                    13,
                                                                                    $event.key,
                                                                                    "Enter"
                                                                                  )
                                                                                )
                                                                                  return null
                                                                                return _vm.searchGene(
                                                                                  _vm.geneToSearch
                                                                                )
                                                                              },
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.geneToSearch =
                                                                                  $event.target.value
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "button",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.searchGene(
                                                                                  _vm.geneToSearch
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "svg",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "20px",
                                                                                },
                                                                              style: `display:${
                                                                                !_vm.geneLoading
                                                                                  ? "block"
                                                                                  : "none"
                                                                              }`,
                                                                              attrs:
                                                                                {
                                                                                  viewBox:
                                                                                    "0 0 24 24",
                                                                                  fill: "none",
                                                                                  xmlns:
                                                                                    "http://www.w3.org/2000/svg",
                                                                                  stroke:
                                                                                    "#000",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "path",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "fill-rule":
                                                                                        "evenodd",
                                                                                      "clip-rule":
                                                                                        "evenodd",
                                                                                      d: "M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z",
                                                                                      fill: "#080341",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "geneLoader",
                                                                              style: `display:${
                                                                                _vm.geneLoading
                                                                                  ? "block"
                                                                                  : "none"
                                                                              }`,
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm
                                                                    .genesNotFound
                                                                    .length > 0
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              display:
                                                                                "flex",
                                                                              "flex-direction":
                                                                                "column",
                                                                              gap: "1px",
                                                                              flex: "0 0 auto",
                                                                              "max-height":
                                                                                "100%",
                                                                              "overflow-y":
                                                                                "auto",
                                                                            },
                                                                        },
                                                                        _vm._l(
                                                                          _vm.genesNotFound,
                                                                          function (
                                                                            gene
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    gap: "5px",
                                                                                    width:
                                                                                      "100%",
                                                                                    background:
                                                                                      "#ff4500",
                                                                                    color:
                                                                                      "white",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        display:
                                                                                          "flex",
                                                                                        flex: "1",
                                                                                        "align-items":
                                                                                          "center",
                                                                                        padding:
                                                                                          "0 5px",
                                                                                        "font-size":
                                                                                          "12px",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        gene
                                                                                      ) +
                                                                                        " not found."
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        width:
                                                                                          "28px",
                                                                                        height:
                                                                                          "28px",
                                                                                        display:
                                                                                          "flex",
                                                                                        "align-items":
                                                                                          "center",
                                                                                        "justify-content":
                                                                                          "center",
                                                                                        "font-size":
                                                                                          "18px",
                                                                                        "line-height":
                                                                                          "18px",
                                                                                        cursor:
                                                                                          "pointer",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.clearGeneNotFound(
                                                                                            gene
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "×"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        2
                                                      ),
                                                      _c("download-chart", {
                                                        staticStyle: {
                                                          width: "125px",
                                                          "align-self":
                                                            "flex-start",
                                                        },
                                                        style: `${
                                                          _vm.expressionDownloadDisabled
                                                            ? "pointer-events:none; opacity:0.5"
                                                            : ""
                                                        }`,
                                                        attrs: {
                                                          chartId:
                                                            _vm.expressionDownloadChartId,
                                                          titleText:
                                                            _vm.expressionSectionTitle,
                                                          filename:
                                                            _vm.expressionDownloadFilename,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.showExpressionPlotTypeSelect
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "5px",
                                                            "align-items":
                                                              "center",
                                                            "align-self":
                                                              "flex-end",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                "white-space":
                                                                  "nowrap",
                                                                opacity: "0.7",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Plot type"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.stratifyPlotType,
                                                                  expression:
                                                                    "stratifyPlotType",
                                                                },
                                                              ],
                                                              staticStyle: {
                                                                width: "125px",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.stratifyPlotType =
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                  },
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.availableExpressionPlotTypes,
                                                              function (
                                                                option
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    key: option,
                                                                    domProps: {
                                                                      value:
                                                                        option,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.stratifyPlotTypeLabel(
                                                                            option
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              !_vm.contExprResults
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel === ""
                                                        ? [
                                                            _vm.stratifyPlotType ===
                                                            "dot"
                                                              ? _c(
                                                                  "research-dot-plot",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "flex",
                                                                        "align-self":
                                                                          "center",
                                                                      },
                                                                    attrs: {
                                                                      data: _vm
                                                                        .geneExpressionVars
                                                                        .expressionStats,
                                                                      xKey: _vm
                                                                        .geneExpressionVars
                                                                        .selectedLabel,
                                                                      yKey: "gene",
                                                                      xLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedLabel
                                                                        ),
                                                                      yLabel:
                                                                        _vm
                                                                          .geneExpressionVars
                                                                          .selectedGene,
                                                                      fillKey:
                                                                        "mean",
                                                                      sizeKey:
                                                                        "pctExpr",
                                                                      fitToSize: true,
                                                                      cellWidth: 30,
                                                                      highlightKey:
                                                                        "",
                                                                      showYLabels: false,
                                                                      showYTicks: true,
                                                                      colorScale:
                                                                        _vm.expressionColorScale,
                                                                      colorScaleMode:
                                                                        _vm.dotPlotColorScaleMode,
                                                                    },
                                                                  }
                                                                )
                                                              : _c(
                                                                  "research-violin-plot",
                                                                  {
                                                                    attrs: {
                                                                      data: _vm
                                                                        .geneExpressionVars
                                                                        .expressionStats,
                                                                      primaryKey:
                                                                        _vm
                                                                          .geneExpressionVars
                                                                          .selectedLabel,
                                                                      subsetKey:
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .segmentByLabel,
                                                                      highlightKey:
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .highlightLabel,
                                                                      height: 300,
                                                                      xAxisLabel:
                                                                        "Log-Normalized Expression",
                                                                      xAxisLabel:
                                                                        _vm.isATACseq
                                                                          ? "Gene Activity Score"
                                                                          : "Log-Normalized Expression",
                                                                      yAxisLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedLabel
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  opacity:
                                                                    "0.5",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "research-single-cell-selector",
                                                              {
                                                                attrs: {
                                                                  data: _vm.plotMetadataLabels,
                                                                  layout:
                                                                    "list",
                                                                  listDirection:
                                                                    "horizontal",
                                                                  listAlignment:
                                                                    "start",
                                                                  colors:
                                                                    _vm.labelColors,
                                                                  selectedField:
                                                                    _vm
                                                                      .cellCompositionVars
                                                                      .segmentByLabel,
                                                                },
                                                                on: {
                                                                  "on-update":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleSelectorUpdate(
                                                                        $event
                                                                      )
                                                                    },
                                                                  "on-hover":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleSelectorHover(
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        : [
                                                            _vm.stratifyPlotType ===
                                                            "dot"
                                                              ? _c(
                                                                  "research-dot-plot",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "flex",
                                                                        "align-self":
                                                                          "center",
                                                                      },
                                                                    attrs: {
                                                                      data: _vm.allSegmentStats,
                                                                      xKey: _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel,
                                                                      yKey: _vm
                                                                        .geneExpressionVars
                                                                        .selectedLabel,
                                                                      xLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .segmentByLabel
                                                                        ),
                                                                      yLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedLabel
                                                                        ),
                                                                      fillKey:
                                                                        "mean",
                                                                      sizeKey:
                                                                        "pctExpr",
                                                                      fitToSize: true,
                                                                      cellWidth: 30,
                                                                      highlightKey:
                                                                        "",
                                                                      colorScale:
                                                                        _vm.expressionColorScale,
                                                                      colorScaleMode:
                                                                        _vm.dotPlotColorScaleMode,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm.stratifyPlotType ===
                                                                "combined"
                                                              ? _c(
                                                                  "research-violin-plot",
                                                                  {
                                                                    attrs: {
                                                                      data: _vm
                                                                        .geneExpressionVars
                                                                        .expressionStats,
                                                                      primaryKey:
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .segmentByLabel,
                                                                      subsetKey:
                                                                        _vm
                                                                          .geneExpressionVars
                                                                          .selectedLabel,
                                                                      facetRows: true,
                                                                      facetRowHeight: 55,
                                                                      facetAxisLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedLabel
                                                                        ),
                                                                      highlightKey:
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .highlightLabel,
                                                                      height: 320,
                                                                      xAxisLabel:
                                                                        "Log-Normalized Expression",
                                                                      xAxisLabel:
                                                                        _vm.isATACseq
                                                                          ? "Gene Activity Score"
                                                                          : "Log-Normalized Expression",
                                                                      yAxisLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .segmentByLabel
                                                                        ),
                                                                      range: [
                                                                        _vm.minExpressionValue(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedGene
                                                                        ),
                                                                        _vm.maxExpressionValue(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedGene
                                                                        ),
                                                                      ],
                                                                    },
                                                                  }
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      id: "sc_violin_plot_group",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "12px",
                                                                            opacity:
                                                                              "0.5",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.displayLabel(
                                                                              _vm
                                                                                .cellCompositionVars
                                                                                .segmentByLabel
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._l(
                                                                      _vm.getPlotMetadataLabels(
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .segmentByLabel
                                                                      ),
                                                                      function (
                                                                        value
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: value,
                                                                            staticStyle:
                                                                              {
                                                                                "content-visibility":
                                                                                  "auto",
                                                                                "contain-intrinsic-size":
                                                                                  "auto 340px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    gap: "3px",
                                                                                    "align-items":
                                                                                      "baseline",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-weight":
                                                                                          "bold",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        value
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "research-violin-plot",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    data: _vm.statsFor(
                                                                                      value
                                                                                    ),
                                                                                    primaryKey:
                                                                                      _vm
                                                                                        .geneExpressionVars
                                                                                        .selectedLabel,
                                                                                    highlightKey:
                                                                                      _vm
                                                                                        .cellCompositionVars
                                                                                        .highlightLabel,
                                                                                    height: 300,
                                                                                    xAxisLabel:
                                                                                      "Log-Normalized Expression",
                                                                                    yAxisLabel:
                                                                                      _vm.displayLabel(
                                                                                        _vm
                                                                                          .geneExpressionVars
                                                                                          .selectedLabel
                                                                                      ),
                                                                                    range:
                                                                                      [
                                                                                        _vm.minExpressionValue(
                                                                                          _vm
                                                                                            .geneExpressionVars
                                                                                            .selectedGene
                                                                                        ),
                                                                                        _vm.maxExpressionValue(
                                                                                          _vm
                                                                                            .geneExpressionVars
                                                                                            .selectedGene
                                                                                        ),
                                                                                      ],
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      }
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.contExprResults
                                                ? _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        id: "sc_expression_scatter_group",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            opacity: "0.5",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .displayByLabel
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-wrap": "wrap",
                                                            gap: "10px",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.contExprResults,
                                                          function (item) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "250px",
                                                                  flex: "1",
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.groupKey
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "research-scatter-plot",
                                                                  {
                                                                    attrs: {
                                                                      data: item.data,
                                                                      width: 300,
                                                                      height: 150,
                                                                      xKey: _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel,
                                                                      yKey: _vm
                                                                        .geneExpressionVars
                                                                        .selectedGene,
                                                                      xLabel:
                                                                        _vm.displayLabel(
                                                                          _vm
                                                                            .cellCompositionVars
                                                                            .segmentByLabel
                                                                        ),
                                                                      yLabel:
                                                                        "Log-Norm. Expression",
                                                                      yDomain: [
                                                                        0,
                                                                        Math.ceil(
                                                                          _vm.maxExpressionValue(
                                                                            _vm
                                                                              .geneExpressionVars
                                                                              .selectedGene
                                                                          )
                                                                        ),
                                                                      ],
                                                                      renderAs:
                                                                        "svg",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "flex", gap: "25px" },
                                },
                                [
                                  _vm.markers &&
                                  (_vm.markerGenes ||
                                    _vm.expressionStatsAll.length > 0)
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "20px",
                                            background: "white",
                                            padding: "20px",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                gap: "20px",
                                                "min-width": "50%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "10px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "strong",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Top Marker Genes for "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.dotPlotCellType,
                                                                  expression:
                                                                    "dotPlotCellType",
                                                                },
                                                              ],
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.dotPlotCellType =
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showMarkersByCellType(
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                                ],
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "",
                                                                  },
                                                                },
                                                                [_vm._v("All")]
                                                              ),
                                                              _vm._l(
                                                                _vm.markerCellTypes,
                                                                function (
                                                                  label
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            label,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            label
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                          _vm.markerFileOptions
                                                            .length
                                                            ? _c(
                                                                "select",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.markerFile,
                                                                      expression:
                                                                        "markerFile",
                                                                    },
                                                                  ],
                                                                  on: {
                                                                    change: [
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$selectedVal =
                                                                          Array.prototype.filter
                                                                            .call(
                                                                              $event
                                                                                .target
                                                                                .options,
                                                                              function (
                                                                                o
                                                                              ) {
                                                                                return o.selected
                                                                              }
                                                                            )
                                                                            .map(
                                                                              function (
                                                                                o
                                                                              ) {
                                                                                var val =
                                                                                  "_value" in
                                                                                  o
                                                                                    ? o._value
                                                                                    : o.value
                                                                                return val
                                                                              }
                                                                            )
                                                                        _vm.markerFile =
                                                                          $event
                                                                            .target
                                                                            .multiple
                                                                            ? $$selectedVal
                                                                            : $$selectedVal[0]
                                                                      },
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleMarkerFileChange()
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.markerFileOptions,
                                                                  function (
                                                                    file
                                                                  ) {
                                                                    return _c(
                                                                      "option",
                                                                      {
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              file,
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            file.markerKeyLabel
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            : _c(
                                                                "strong",
                                                                {
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "16px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Cell Types"
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("download-chart", {
                                                    staticStyle: {
                                                      width: "125px",
                                                      "align-self":
                                                        "flex-start",
                                                    },
                                                    attrs: {
                                                      chartId:
                                                        "sc_marker_dot_plot",
                                                      titleText:
                                                        _vm.markerDotPlotTitle,
                                                      filename:
                                                        _vm.markerDownloadFilename,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "12px",
                                                      opacity: "0.5",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Ranked by " +
                                                        _vm._s(
                                                          _vm.markerRankingLabel
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "13px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Select a type to view its full marker profile."
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c("research-dot-plot", {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-self": "center",
                                                },
                                                attrs: {
                                                  wrapperId:
                                                    "sc_marker_dot_plot",
                                                  data:
                                                    _vm.markerGenes ||
                                                    _vm.expressionStatsAll,
                                                  "data-blah":
                                                    "pct_cells_expression",
                                                  yKey: _vm.markerFile
                                                    .markerKey,
                                                  xKey: "gene",
                                                  xDomain: _vm.markerGeneOrder,
                                                  yLabel:
                                                    _vm.markerFile
                                                      .markerKeyLabel,
                                                  xLabel: "Gene",
                                                  fillKey: "mean_expression",
                                                  sizeKey:
                                                    _vm.markerGenesSizeKey,
                                                  fitToSize: true,
                                                  cellWidth: 30,
                                                  highlightKey: "",
                                                  colorScale:
                                                    _vm.expressionColorScale,
                                                  colorScaleMode:
                                                    _vm.dotPlotColorScaleMode,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.markerGenesTable
                                            ? _c("b-table", {
                                                staticStyle: {
                                                  "font-size": "12px",
                                                },
                                                attrs: {
                                                  items: _vm.markerGenesTable,
                                                  fields:
                                                    _vm.markerTableColumns,
                                                  striped: "",
                                                  hover: "",
                                                  small: "",
                                                  responsive: "sm",
                                                  "head-variant": "light",
                                                  "sticky-header": "300px",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.layout === 1
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        width: "100%",
                        "align-self": "center",
                      },
                    },
                    [
                      _c("research-single-cell-info", {
                        attrs: { data: _vm.metadata },
                      }),
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "40px",
                                flex: "1",
                              },
                            },
                            [
                              _c("research-single-cell-selector", {
                                staticStyle: { "max-width": "200px" },
                                attrs: {
                                  data:
                                    _vm.fields["metadata_labels_sorted"] ||
                                    _vm.fields["metadata_labels"],
                                  layout: "dropdown-list",
                                  showSelect: false,
                                  colors: _vm.labelColors,
                                  selectedField:
                                    _vm.cellCompositionVars.colorByField,
                                },
                                on: {
                                  "on-update": function ($event) {
                                    return _vm.handleSelectorUpdate($event)
                                  },
                                  "on-hover": function ($event) {
                                    return _vm.handleSelectorHover($event)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    gap: "20p",
                                    width: "400px",
                                  },
                                },
                                [
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            flex: "1",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "baseline",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.embeddingType
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.geneExpressionVars
                                                            .selectedGene
                                                            ? `${_vm.geneExpressionVars.selectedGene}`
                                                            : ""
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.cellCountLabel) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c("research-umap-plot-gl", {
                                                attrs: {
                                                  downloadFilename:
                                                    _vm.umapExpressionDownloadFilename,
                                                  group: _vm.datasetId,
                                                  points: _vm.coordinates,
                                                  labels: _vm.fields,
                                                  colors: _vm.labelColors,
                                                  expression:
                                                    _vm.expressionData[
                                                      _vm.geneExpressionVars
                                                        .selectedGene
                                                    ],
                                                  expressionColorScale:
                                                    _vm.expressionColorScale,
                                                  cellTypeField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  hoverFields: [],
                                                  highlightLabel:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  highlightLabels:
                                                    _vm.cellCompositionVars
                                                      .highlightLabels,
                                                  visibleMask:
                                                    _vm.cellFilterMask,
                                                  width: 400,
                                                  height: 400,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm.geneExpressionVars.expressionStats.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        flex: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "5px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [_vm._v("Gene Expression")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-style": "italic",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.geneExpressionVars
                                                        .selectedGene
                                                        ? `${_vm.geneExpressionVars.selectedGene}`
                                                        : ""
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("research-violin-plot", {
                                        attrs: {
                                          data: _vm.geneExpressionVars
                                            .expressionStats,
                                          primaryKey:
                                            _vm.geneExpressionVars
                                              .selectedLabel,
                                          subsetKey:
                                            _vm.geneExpressionVars.subsetLabel,
                                          highlightKey:
                                            _vm.cellCompositionVars
                                              .highlightLabel,
                                          height: 400,
                                          xAxisLabel:
                                            "Log-Normalized Expression",
                                          yAxisLabel:
                                            _vm.geneExpressionVars
                                              .selectedLabel,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.layout === 2
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "20px",
                        background: "#f8f8f8",
                        padding: "20px",
                        width: "100%",
                        "min-width": "840px",
                      },
                    },
                    [
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                gap: "20px",
                              },
                            },
                            [
                              _vm.metadata
                                ? _c("research-single-cell-info", {
                                    attrs: { data: _vm.metadata },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "flex", gap: "20px" },
                                },
                                [
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "20px",
                                            flex: "1",
                                            padding: "20px",
                                            background: "white",
                                          },
                                        },
                                        [
                                          _vm.colorByFields
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    "align-self": "flex-start",
                                                    width: "400px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                        margin: "0 0 5px",
                                                      },
                                                    },
                                                    [_vm._v("Color By")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        height: "400px",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .colorByField,
                                                              expression:
                                                                "cellCompositionVars.colorByField",
                                                            },
                                                          ],
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  _vm.cellCompositionVars,
                                                                  "colorByField",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.selectColorBy(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "--Select--"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.colorByFields
                                                              .show,
                                                            function (
                                                              value,
                                                              key
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value: key,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          key
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "flex-grow": "1",
                                                            "overflow-x":
                                                              "hidden",
                                                            "overflow-y":
                                                              "auto",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "research-single-cell-selector",
                                                            {
                                                              attrs: {
                                                                data:
                                                                  _vm.fields[
                                                                    "metadata_labels_sorted"
                                                                  ] ||
                                                                  _vm.fields[
                                                                    "metadata_labels"
                                                                  ],
                                                                displayData:
                                                                  _vm.displayFields,
                                                                selectedField:
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .colorByField,
                                                                layout: "list",
                                                                colors:
                                                                  _vm.labelColors,
                                                              },
                                                              on: {
                                                                "on-update":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorUpdate(
                                                                      $event
                                                                    )
                                                                  },
                                                                "on-hover":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorHover(
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                width: "min-content",
                                                flex: "1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    "align-items": "baseline",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [_vm._v("Embedding")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.embeddingType
                                                        )
                                                    ),
                                                  ]),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(_vm.cellCountLabel)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("research-umap-plot-gl", {
                                                attrs: {
                                                  downloadFilename:
                                                    _vm.umapDownloadFilename,
                                                  group: _vm.datasetId,
                                                  points: _vm.coordinates,
                                                  labels: _vm.fields,
                                                  colors: _vm.labelColors,
                                                  cellTypeField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  colorByField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  hoverFields: [],
                                                  highlightLabel:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  highlightLabels:
                                                    _vm.cellCompositionVars
                                                      .highlightLabels,
                                                  visibleMask:
                                                    _vm.cellFilterMask,
                                                  width: 400,
                                                  height: 400,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.layout === 3
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        width: "100%",
                        "align-self": "center",
                      },
                    },
                    [
                      _c("research-single-cell-info", {
                        attrs: { data: _vm.metadata },
                      }),
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "40px",
                                flex: "1",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    gap: "20px",
                                    flex: "1",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        flex: "1",
                                        gap: "20px",
                                        padding: "20px",
                                        background: "white",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-between",
                                            gap: "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isATACseq
                                                        ? "Nuclei"
                                                        : "Cell"
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.isNormalized
                                                          ? "Proportion"
                                                          : "Count"
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _vm.displayFields &&
                                              _vm.cellCompositionVars
                                                .segmentByLabel &&
                                              _vm.displayFields[
                                                _vm.cellCompositionVars
                                                  .segmentByLabel
                                              ].dataType === "cat"
                                                ? [
                                                    _vm._v(" by "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .displayByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" per "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.cellCompositionVars
                                                    .segmentByLabel
                                                ? [
                                                    _vm._v(" by "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" per "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .displayByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(" by "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .displayByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                              _vm.displayFields &&
                                              _vm.cellCompositionVars
                                                .segmentByLabel &&
                                              _vm.displayFields[
                                                _vm.cellCompositionVars
                                                  .segmentByLabel
                                              ].dataType === "cont"
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Each point represents the average " +
                                                            _vm._s(
                                                              _vm.isATACseq
                                                                ? "nuclei"
                                                                : "cell"
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.isNormalized
                                                                ? "proportion"
                                                                : "distribution"
                                                            ) +
                                                            " per " +
                                                            _vm._s(
                                                              this.aggregateType
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _c("download-chart", {
                                            staticStyle: {
                                              width: "125px",
                                              "align-self": "flex-start",
                                            },
                                            style: `${
                                              _vm.countDownloadDisabled
                                                ? "pointer-events:none; opacity:0.5"
                                                : ""
                                            }`,
                                            attrs: {
                                              chartId: _vm.countDownloadChartId,
                                              titleText: _vm.countSectionTitle,
                                              filename:
                                                _vm.countDownloadFilename,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      !_vm.cellCompositionVars.segmentByLabel ||
                                      (_vm.displayFields &&
                                        _vm.displayFields[
                                          _vm.cellCompositionVars.segmentByLabel
                                        ].dataType === "cat")
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                gap: "5px",
                                              },
                                            },
                                            [
                                              _c("research-stacked-bar-plot", {
                                                attrs: {
                                                  data: _vm.cellCompositionVars
                                                    .segmentByCounts2,
                                                  primaryKey: _vm
                                                    .cellCompositionVars
                                                    .segmentByLabel
                                                    ? _vm.cellCompositionVars
                                                        .segmentByLabel
                                                    : _vm.cellCompositionVars
                                                        .displayByLabel,
                                                  subsetKey: _vm
                                                    .cellCompositionVars
                                                    .segmentByLabel
                                                    ? _vm.cellCompositionVars
                                                        .displayByLabel
                                                    : _vm.cellCompositionVars
                                                        .segmentByLabel,
                                                  xAxisLabel:
                                                    _vm.useVerticalCellProportionPlot
                                                      ? `${
                                                          _vm.isNormalized
                                                            ? "Percent of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                            : "Number of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                        }`
                                                      : _vm.cellCompositionVars
                                                          .segmentByLabel
                                                      ? _vm.displayLabel(
                                                          _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel
                                                        )
                                                      : _vm.displayLabel(
                                                          _vm
                                                            .cellCompositionVars
                                                            .displayByLabel
                                                        ),
                                                  yAxisLabel:
                                                    _vm.useVerticalCellProportionPlot
                                                      ? _vm.cellCompositionVars
                                                          .segmentByLabel
                                                        ? _vm.displayLabel(
                                                            _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          )
                                                        : _vm.displayLabel(
                                                            _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          )
                                                      : `${
                                                          _vm.isNormalized
                                                            ? "Percent of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                            : "Number of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                        }`,
                                                  highlightKey:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  normalize: _vm.isNormalized,
                                                  stack: _vm.cellCompositionVars
                                                    .segmentByLabel
                                                    ? true
                                                    : false,
                                                  verticalCategoryLayout:
                                                    _vm.useVerticalCellProportionPlot,
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    opacity: "0.5",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel
                                                        ? _vm.displayLabel(
                                                            _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          )
                                                        : _vm.displayLabel(
                                                            _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "research-single-cell-selector",
                                                {
                                                  attrs: {
                                                    data: _vm.plotMetadataLabels,
                                                    layout: "list",
                                                    listDirection: "horizontal",
                                                    listAlignment: "start",
                                                    colors: _vm.labelColors,
                                                    selectedField: _vm
                                                      .cellCompositionVars
                                                      .segmentByLabel
                                                      ? _vm.cellCompositionVars
                                                          .displayByLabel
                                                      : _vm.cellCompositionVars
                                                          .segmentByLabel,
                                                  },
                                                  on: {
                                                    "on-update": function (
                                                      $event
                                                    ) {
                                                      return _vm.handleSelectorUpdate(
                                                        $event
                                                      )
                                                    },
                                                    "on-hover": function (
                                                      $event
                                                    ) {
                                                      return _vm.handleSelectorHover(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.contCountResults
                                        ? _c(
                                            "div",
                                            {
                                              attrs: {
                                                id: "sc_count_scatter_group",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    opacity: "0.5",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayLabel(
                                                        _vm.cellCompositionVars
                                                          .displayByLabel
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-wrap": "wrap",
                                                    gap: "10px",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.contCountResults,
                                                  function (item) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "min-width": "250px",
                                                          flex: "1",
                                                        },
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.groupKey
                                                            )
                                                          ),
                                                        ]),
                                                        _c(
                                                          "research-scatter-plot",
                                                          {
                                                            attrs: {
                                                              data: item.data,
                                                              width: 300,
                                                              height: 150,
                                                              xKey: _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel,
                                                              yKey: "cell_proportion",
                                                              xLabel:
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                ),
                                                              yLabel:
                                                                "Cell Proportion",
                                                              yDomain: [0, 1],
                                                              renderAs: "svg",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        gap: "25px",
                                      },
                                    },
                                    [
                                      _vm.markers &&
                                      (_vm.markerGenes ||
                                        _vm.expressionStatsAll.length > 0)
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                gap: "20px",
                                                background: "white",
                                                padding: "20px",
                                                width: "100%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    gap: "20px",
                                                    "min-width": "50%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "strong",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "16px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.dotPlotCellType !=
                                                                    ""
                                                                    ? `Marker Genes for ${_vm.dotPlotCellType}`
                                                                    : "Top Marker Genes by Cell Type"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                opacity: "0.5",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Ranked by " +
                                                                  _vm._s(
                                                                    _vm.markerRankingLabel
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "20px",
                                                          },
                                                        },
                                                        [
                                                          _c("download-chart", {
                                                            staticStyle: {
                                                              width: "125px",
                                                              "align-self":
                                                                "flex-start",
                                                            },
                                                            attrs: {
                                                              chartId:
                                                                "sc_dot_plot",
                                                              filename:
                                                                _vm.markerDownloadFilename,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                  _c("research-dot-plot", {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-self": "center",
                                                    },
                                                    attrs: {
                                                      data:
                                                        _vm.markerGenes ||
                                                        _vm.expressionStatsAll,
                                                      "data-blah":
                                                        "pct_cells_expression",
                                                      yKey: _vm.markerFile
                                                        .markerKey,
                                                      xKey: "gene",
                                                      xDomain:
                                                        _vm.markerGeneOrder,
                                                      yLabel:
                                                        _vm.markerFile
                                                          .markerKeyLabel,
                                                      xLabel: "Gene",
                                                      fillKey:
                                                        "mean_expression",
                                                      sizeKey:
                                                        _vm.markerGenesSizeKey,
                                                      fitToSize: true,
                                                      cellWidth: 30,
                                                      highlightKey: "",
                                                      colorScale:
                                                        _vm.expressionColorScale,
                                                      colorScaleMode:
                                                        _vm.dotPlotColorScaleMode,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.markerGenesTable
                                                ? _c("b-table", {
                                                    attrs: {
                                                      items:
                                                        _vm.markerGenesTable,
                                                      fields:
                                                        _vm.markerTableColumns,
                                                      "current-page":
                                                        _vm.markerGenesPage,
                                                      "per-page": 10,
                                                      hover: "",
                                                      small: "",
                                                      responsive: "sm",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("b-pagination", {
                                                attrs: {
                                                  "total-rows":
                                                    _vm.markerGenesTable.length,
                                                  "per-page": 10,
                                                },
                                                model: {
                                                  value: _vm.markerGenesPage,
                                                  callback: function ($$v) {
                                                    _vm.markerGenesPage = $$v
                                                  },
                                                  expression: "markerGenesPage",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }